import { render, staticRenderFns } from "./login.vue?vue&type=template&id=7a63c5d0&scoped=true"
import script from "./login.ts?vue&type=script&lang=ts&external"
export * from "./login.ts?vue&type=script&lang=ts&external"
import style0 from "./login.vue?vue&type=style&index=0&id=7a63c5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63c5d0",
  null
  
)

export default component.exports